module.exports = __webpack_public_path__ + "img/build1.a415f9cb.png";